/**
 * Returns a URL suitable for <img src="...">.
 * - ImageKit / normal URLs: returned as-is.
 * - Google Drive: converted to direct URL; if options.apiBaseUrl is set, returns
 *   a proxy URL so the image is served from your backend (avoids Drive blocking embedding).
 *
 * @param {string} url - Image URL (ImageKit, Google Drive share link, etc.)
 * @param {{ apiBaseUrl?: string }} [options] - If apiBaseUrl is set, Drive URLs use backend proxy
 */
export function getDisplayImageUrl(url, options = {}) {
  if (!url || typeof url !== 'string') return url || '';

  const trimmed = url.trim();

  // Only convert Google Drive links; pass through ImageKit and all other URLs unchanged
  if (!trimmed.includes('drive.google.com')) {
    return trimmed;
  }

  let directDriveUrl = '';

  // Google Drive: /file/d/FILE_ID/view
  const fileIdMatch = trimmed.match(/\/file\/d\/([a-zA-Z0-9_-]+)/);
  if (fileIdMatch) {
    directDriveUrl = `https://drive.google.com/uc?id=${fileIdMatch[1]}`;
  } else {
    // Google Drive: open?id=FILE_ID or uc?id=FILE_ID
    const idParamMatch = trimmed.match(/[?&]id=([a-zA-Z0-9_-]+)/);
    if (idParamMatch) {
      directDriveUrl = `https://drive.google.com/uc?id=${idParamMatch[1]}`;
    } else {
      return trimmed;
    }
  }

  // Use backend proxy so the image is served from our domain (Drive blocks direct embedding)
  const apiBase = options.apiBaseUrl ? options.apiBaseUrl.replace(/\/$/, '') : '';
  if (apiBase) {
    return `${apiBase}/api/proxy-image?url=${encodeURIComponent(directDriveUrl)}`;
  }

  return directDriveUrl;
}
